export default "__VITE_ASSET__DZyKT$PZ__"